import React from 'react'
import { SpeedDialInterface } from 'interfaces'
import { useHistory } from 'react-router'
import { Grid, Hidden, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  mainContent: {
    background: '#fff',
    borderRadius: '10px',
    height: '100%',
    paddingTop: '20px',
    paddingLeft: '15px',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.15)',
    margin: '0px 6px',
    paddingBottom: '20px',
    marginBottom: '10px',
  },
  linkTitle: {
    cursor: 'pointer',
  },
  img: {
    position: 'relative',
    top: '5px',
    left: '-5px',
  },
  imgArrow: {
    position: 'relative',
    top: '-40px',
    right: '-90%',
  },
  listItem: {
    display: 'list-item',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
    color: '#3D2294',
    marginLeft: '30px',
    marginTop: '10px',
  },
  listContent: {
    fontSize: '14px',
    lineHeight: '22px',
    marginLeft: '30px',
  },
  title: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
    display: 'inline-block',
    color: '#039F5E'
  },
  question: {
    fontWeight: 400,
    fontSize: '11px',
    lineHeight: '17px',
    display: 'block',
    color: '#555555',
    paddingLeft: '20px'
  },
  content: {
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: '17px',
    display: 'block',
    color: '#555555',
    padding: '0 20px',
    marginTop: '20px',
    textAlign: 'justify',
  }
}))
const InfoView: React.FC = () => {
  const [helpView, setHelpView] = React.useState(false)
  const [speedUp, setSpeedUp] = React.useState(false)
  const history = useHistory()
  const classes = useStyles()
  return (
    <>
      <Hidden xsDown>
        <Grid container xs={12}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={classes.mainContent}>
            <img className={classes.img} src="/images/help.svg" />
            <span className={classes.title}>راهنمای درخواست دارو</span>
            <span className={classes.question}>چگونه درخواست داروی خود را ثبت کنیم؟</span>
            <span className={classes.content}>
              کاربر گرامی، شما می توانید از طریق انتخاب گزینه ی
              <span style={{ textDecoration: 'underline', fontWeight: 700 }}> درخواست دارو </span>
              از منوی بالا، نسبت به درخواست داروی بدون نسخه یا ثبت نسخه ی مورد نظر خود اقدام نمایید. همچنین در صورتیکه نسخه ی شما الکترونیک است کافیست کد رهگیری آن را ثبت نمایید. سامانه ی داروگ درخواست شما را در سریعترین زمان برای تمامی داروخانه های کشور ارسال و نتیحه آن از طریق پیامک برای شما ارسال خواهد شد.
            </span>
          </Grid>
        </Grid>
        <Grid container xs={12}>
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={classes.mainContent}>
            <img className={classes.img} src="/images/arrowUp.png" />
            <span className={classes.title}> شتاب دهی درخواست</span>
            <span className={classes.question}>چگونه سرعت جستجوی داروی خود را افزایش دهیم؟</span>
            <span className={classes.content}>
              در صورتیکه برای درخواست خود عجله دارید میتوانید از طریق انتخاب
              <span style={{ color: '#3D2294', fontWeight: 700 }}> شتاب دهی </span>
              در هنگام ثبت درخواست سرعت یافتن داروی خود را افزایش دهید:
              <span className={classes.listItem}>
                شتاب دهی صدر نشین:
              </span>
              <span className={classes.listContent}>
                با انتخاب این گزینه، آگهی شمابه مدت سه روز در لیست داروخانه ها، بالاتر از بقیه آگهی ها با برچسب ویژه نمایش داده خواهد شد.
              </span>
              <span className={classes.listItem}>
                شتاب دهی پشتیبان:
              </span>
              <span className={classes.listContent}>
                با انتخاب یک گزینه یک  نفر
                <span style={{ color: '#008D52', fontWeight: 700 }}> کارشناس پشتیبان </span>
                بصورت تلفنی در فرآیند جستجوی دارو به کمک شما خواهد آمد.
              </span>
            </span>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={classes.mainContent}>
          <div onClick={(): any => setHelpView(!helpView)} className={classes.linkTitle}>
            <img className={classes.img} src="/images/help.png" />
            <span className={classes.title}>راهنمای درخواست دارو</span>
            <span className={classes.question}>چگونه درخواست داروی خود را ثبت کنیم؟</span>
            <img className={classes.imgArrow} src="/images/arrowDown.png" />
          </div>
          {helpView == true && (
            <>
              <span className={classes.content}>
                کاربر گرامی، شما می توانید از طریق انتخاب گزینه ی
                <span style={{ textDecoration: 'underline', fontWeight: 700 }}> درخواست دارو </span>
                از منوی بالا، نسبت به درخواست داروی بدون نسخه یا ثبت نسخه ی مورد نظر خود اقدام نمایید. همچنین در صورتیکه نسخه ی شما الکترونیک است کافیست کد رهگیری آن را ثبت نمایید. سامانه ی داروگ درخواست شما را در سریعترین زمان برای تمامی داروخانه های کشور ارسال و نتیحه آن از طریق پیامک برای شما ارسال خواهد شد.
              </span>
            </>
          )}
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={classes.mainContent}>
          <div onClick={(): any => setSpeedUp(!speedUp)} className={classes.linkTitle}>
            <img className={classes.img} src="/images/arrowUp.png" />
            <span className={classes.title}> شتاب دهی درخواست</span>
            <span className={classes.question}>چگونه سرعت جستجوی داروی خود را افزایش دهیم؟</span>
            <img className={classes.imgArrow} src="/images/arrowDown.png" />
          </div>
          {speedUp == true && (
            <>
              <span className={classes.content}>
                در صورتیکه برای درخواست خود عجله دارید میتوانید از طریق انتخاب
                <span style={{ color: '#3D2294', fontWeight: 700 }}> شتاب دهی </span>
                در هنگام ثبت درخواست سرعت یافتن داروی خود را افزایش دهید:
              </span>
              <span className={classes.listItem}>
                شتاب دهی صدر نشین:
              </span>
              <span className={classes.listContent} style={{ marginLeft: '0px' }}>
                با انتخاب این گزینه، آگهی شمابه مدت سه روز در لیست داروخانه ها، بالاتر از بقیه آگهی ها با برچسب ویژه نمایش داده خواهد شد.
              </span>
              <span className={classes.listItem}>
                شتاب دهی پشتیبان:
              </span>
              <span className={classes.listContent} style={{marginLeft: '0px'}}>
                با انتخاب یک گزینه یک  نفر
                <span style={{ color: '#008D52', fontWeight: 700 }}> کارشناس پشتیبان </span>
                بصورت تلفنی در فرآیند جستجوی دارو به کمک شما خواهد آمد.
              </span>
            </>
          )}
        </Grid>
      </Hidden>
    </>
  )
}

export default InfoView
